import { NgModule } from '@angular/core';

import {
  ConfigureTranslateModule,
  KeyAndLoader,
  registerLibTranslation,
} from '@plugins/client/translate/loaders';
import {
  prepareTestTranslateService,
  TranslateService,
} from '@plugins/client/translate/services';

export const TRANSLATION_KEY = 'select';
const loader = (lang: string) => import(`./assets/i18n/${lang}.json`);

const source: KeyAndLoader = {
  loader,
  key: TRANSLATION_KEY,
};

export const loadTranslations = registerLibTranslation(source);

@NgModule()
@loadTranslations
export class SelectTranslateModule extends ConfigureTranslateModule.configureLib(
  source,
) {}

export const testTranslateService = async () => {
  return await prepareTestTranslateService({
    key: TRANSLATION_KEY,
    loaders: loader,
  });
};

export const translateProvider = async () => {
  return {
    provide: TranslateService,
    useValue: await testTranslateService(),
  };
};
